import { render } from "./preview-table.vue?vue&type=template&id=42cee153&lang=pug"
import script from "./preview-table.vue?vue&type=script&lang=js"
export * from "./preview-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__